import request from '@/utils/request'
import httpConfig from './httpConfig'

export function httpService (json) {
  return request({
    url: httpConfig[json.url],
    method: json.method || 'get',
    params: json.params || {},
    data: json.data || {}
  })
}
